import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import { ButtonGroup, Button } from 'react-bootstrap';
import { fullDate, monthNameFormatDate } from '../../../core/date';
import { displayBuyerBidState } from '../../../core/api';
import BidDetailModal from './BidDetailModal';
import StyledGriddle from '../../../components/StyledGriddle';

function findById(value) {
  console.log('findById', value.id, this);
  return value.id === Number(this);
}

const dateDisplay = ({ value }) => {
  return (
    <span> {monthNameFormatDate(value)} </span>
  )
}
const statusDisplay =({value})=> {
  if(value==='Unsent'){
    return(
      <span className='UnsentStaus' >{value}</span>
    )
  }
  return <span>{value}</span>
}

class ProposalTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBid: false,
      showSend: false,
      bidbidsDetails: [],
      isLoading:false,
    };
    this.remove = this.remove.bind(this);
    this.showHotel = this.showHotel.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal() {
    this.setState({
      showBid: false,
      showSend:false,
    });
  }
  remove(bidId) {
    console.log('bid id:', bidId);
    if (bidId) {
      console.log('remove hotel: ', bidId);
      this.setState({ bid: null, showBid: false });
      this.props.removeBid(bidId);
    }
  }
  showHotel(e) {
    this.setState({isLoading:true})
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      console.log('show hotel: ', id);
      this.props.requestBidDetails(id,(response)=>{
        if(response){
          this.setState({
            bidbidsDetails:response.results,
            isLoading:false,
          })
        }
      })
      this.setState({
        bid: id,
        showBid: true,
        showSend: false,
      });
    }
  }
  findBid(id) {
    if (!this.props.proposal) {
      return {};
    }
    if (!this.props.proposal.bids) {
      return {};
    }
    const idx = this.props.proposal.bids.findIndex(findById, id);
    if (idx === -1) {
      console.log('Unable to find bid: ', id);
      return { id };
    }
    return this.props.proposal.bids[idx];
  }

  render() {
    const ButtonColumn = ({ value }) => (
      <ButtonGroup>
        <Button bsStyle="info" data-item={value} onClick={this.showHotel}>
          <i className="fa fa-pencil fa-lg" /> Edit Bid
        </Button>
      </ButtonGroup>
    );

    const bids = [];
    this.props.proposal.bids.forEach(bid => {
      let start
      let end
       this.props.proposal.tour.tour_stops.filter(item => {
        if(bid.bidset){
          if (item.place.name === bid.bidset.event.place.name) {
            return item.related_group_events.filter(itme2=>{
              if(itme2.group === bid.tourgroup_id && itme2.parent === bid.bidset.event.parent){
                start = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].lowest_check_in_date:itme2.start
                end = itme2.bids.bid_details.length>0?itme2.bids.bid_details[0].greatest_check_out_date:itme2.end
              }
            })
          }
          else{
            return null
          }
        }
      });
      const displayState = displayBuyerBidState(bid.buyer_state, bid.bidder_state);
      let location;
      if (bid.hotel.city == null){
        location = `${bid.hotel.state}, ${bid.hotel.country}`;
      };
      if (bid.hotel.state == null){
        location = `${bid.hotel.city}, ${bid.hotel.country}`;
      };
      if (bid.hotel.city == null && bid.hotel.state == null){
        location = `${bid.hotel.country}`;
      };
      if (bid.hotel.city == null && bid.hotel.state == null && bid.hotel.country == null){
        location = '';
      };
      if (bid.hotel.city != null && bid.hotel.state != null && bid.hotel.country != null){
        if (bid.hotel.city === bid.hotel.state){
          location = `${bid.hotel.city}, ${bid.hotel.country}`;
        } else{
          if (bid.hotel.state === bid.hotel.country){
            location = `${bid.hotel.city}, ${bid.hotel.country}`;
          }
          else{
            location = `${bid.hotel.city}, ${bid.hotel.state}, ${bid.hotel.country}`;
          }
        }
      };
      if (['Sent', 'Draft', 'Sending', 'Stay Updated','Unsent'].includes(displayState) && (bid.bidset)) {
        bids.push({
          id: bid.id,
          name: bid.hotel.name,
          group: bid.bidset.event.group_name,
          location,
          distance: parseFloat(bid.distance_to_venue * 0.621371).toFixed(2),
          start:start?start:bid.bidset.event.start,
          end:end?end:bid.bidset.event.end,
          state: displayState,
        });
      }
    });
    return (
      <div>
        <StyledGriddle data={bids}>
          <RowDefinition>
            <ColumnDefinition id="name" title="Hotel" />
            <ColumnDefinition id="group" title="Group" />
            <ColumnDefinition id="location" title="Location" />
            <ColumnDefinition id="distance" title="Distance" />
            <ColumnDefinition id="start" title="Check In" customComponent={dateDisplay} />
            <ColumnDefinition id="end" title="Check Out" customComponent={dateDisplay} />
            <ColumnDefinition id="state" title="Status" customComponent={statusDisplay} />
            <ColumnDefinition id="id" title=" " customComponent={ButtonColumn} />
          </RowDefinition>
        </StyledGriddle>
        {this.state.showBid && (

          <BidDetailModal
            bid={this.findBid(this.state.bid)}
            show={this.state.showBid}
            showSend={this.state.showSend}
            onClose={this.closeModal}
            editBid={this.props.editBid}
            addBidNote={this.props.addBidNote}
            sendBid={this.props.sendBid}
            removeBid={this.remove}
            isTourManager={false}
            readOnly={false}
            user={this.props.user}
            tourData={this.props.tourData}
            editMember={this.props.editMember}
            requestBidDetails={this.props.requestBidDetails}
            bidbidsDetails={this.state.bidbidsDetails}
            isLoading={this.state.isLoading}
          />
        )}
      </div>
    );
  }
}

ProposalTable.propTypes = {
  proposal: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
};

ProposalTable.defaultProps = {
  proposal: {
    bids: [],
  },
};
export default ProposalTable;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalTable.js